import styles from "./product.module.css";
import { forwardRef, useState, useEffect } from "react";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { HeadingTitle, Image } from "../../../shared/index";
import { Link,useNavigate } from "react-router-dom";
import { getImageUrl } from "../../../../lib/get-image";
import toast from "react-hot-toast";

import authService from "../../../../services/authService";

import {
  useAddToWishList,
  useRemoveWishList,
} from "../../../../queries/useWishListQuery";

import {
  useAddToCart,
  useIncreaseCartQty,
  useDecreaseCartQty,
  useGetCart,
} from "../../../../queries/useCartQuery";

const Product = forwardRef(
  (
    {
      product,
      wishItems,
      isWishListPending,
      imageOnly = false,
    },
    ref
  ) => {
    console.log("========== PRODUCT DEBUG ==========");
    console.log("FULL PRODUCT:", product);
    console.log("PRODUCT ID:", product?.id);
    console.log("PRODUCT NAME:", product?.name);
    console.log("THUMB IMAGE:", product?.thumb_image);
    console.log("VARIANTS:", product?.variants);
    console.log("FIRST VARIANT:", product?.variants?.[0]);

    console.log(
      "HOME VARIANT PRICE:",
      product?.variants?.[0]?.price
    );

    console.log(
      "HOME VARIANT OFFER PRICE:",
      product?.variants?.[0]?.offer_price
    );

    console.log(
      "HOME VARIANT QUANTITY:",
      product?.variants?.[0]?.quantity
    );

    console.log(
      "SHOP VARIANT PRICE:",
      product?.variants?.[0]?.variant_price
    );

    console.log(
      "SHOP VARIANT OFFER PRICE:",
      product?.variants?.[0]?.variant_offer_price
    );

    console.log(
      "SHOP VARIANT QUANTITY:",
      product?.variants?.[0]?.variant_qty
    );

    console.log(
      "IMAGE URL:",
      getImageUrl(product?.thumb_image)
    );

    console.log("=================================");

    const { id, name, slug, thumb_image } = product;
const navigate = useNavigate();
    /*
     * =====================================================
     * GET ACTIVE VARIANT
     * =====================================================
     */
    const activeVariant = Array.isArray(product?.variants)
      ? product.variants.find(
          (variant) => variant?.status !== false
        )
      : null;

    /*
     * =====================================================
     * PRICE
     *
     * HOME API:
     * price
     * offer_price
     *
     * SHOP API:
     * variant_price
     * variant_offer_price
     *
     * We support BOTH.
     * =====================================================
     */
    const price = Number(
      activeVariant?.price ??
        activeVariant?.variant_price ??
        product?.price ??
        0
    );

    const offer_price = Number(
      activeVariant?.offer_price ??
        activeVariant?.variant_offer_price ??
        product?.offer_price ??
        0
    );

    /*
     * =====================================================
     * QUANTITY
     *
     * HOME API:
     * quantity
     *
     * SHOP API:
     * variant_qty
     *
     * =====================================================
     */
    const maxQty =
      Number(
        activeVariant?.quantity ??
          activeVariant?.variant_qty ??
          product?.qty ??
          0
      );

    /*
     * =====================================================
     * SKU
     * =====================================================
     */
    const sku =
      activeVariant?.sku ||
      activeVariant?.variant_sku ||
      product?.sku ||
      "";

    console.log("FINAL PRICE:", price);
    console.log("FINAL OFFER PRICE:", offer_price);
    console.log("FINAL QTY:", maxQty);
    console.log("FINAL SKU:", sku);

   const [isLoggedIn, setIsLoggedIn] = useState(
  authService.isLoggedIn()
);

useEffect(() => {
  const syncAuth = () => {
    setIsLoggedIn(authService.isLoggedIn());
  };

  syncAuth();

  window.addEventListener("auth-changed", syncAuth);
  window.addEventListener("storage", syncAuth);
  window.addEventListener("focus", syncAuth);

  return () => {
    window.removeEventListener("auth-changed", syncAuth);
    window.removeEventListener("storage", syncAuth);
    window.removeEventListener("focus", syncAuth);
  };
}, []);

    /* =========================
       CART
    ========================= */

    const { data: cartItems = [] } = useGetCart();

    const { mutate: addToCart, isPending: isAdding } =
      useAddToCart();

    const { mutate: increaseQty } =
      useIncreaseCartQty();

    const { mutate: decreaseQty } =
      useDecreaseCartQty();

  const cartItem = isLoggedIn
  ? cartItems?.find(
      (item) => item.product_id === id
    )
  : null;

const isInCart = isLoggedIn && Boolean(cartItem);

    /* =========================
       WISHLIST
    ========================= */

    const { mutate: addWish } = useAddToWishList();
    const { mutate: removeWish } = useRemoveWishList();

   const wishItem = isLoggedIn
  ? wishItems?.find(
      (w) => w.product_id === id
    )
  : null;

const inWishList = isLoggedIn && Boolean(wishItem);

const wishlistId = wishItem?.id;

    const handleWishlist = (e) => {
  e.preventDefault();
  e.stopPropagation();

  // If user is not logged in, go to login page
  if (!isLoggedIn) {
    navigate("/login");
    return;
  }

  if (inWishList) {
    removeWish(wishlistId);
  } else {
    addWish({ product_id: id });
  }
};

    /* =========================
       PRICE CALCULATION
    ========================= */

    const originalPrice = Number(price) || 0;

    const offerPrice = Number(offer_price) || 0;

    const hasOffer =
      offerPrice > 0 &&
      offerPrice < originalPrice;

    const finalPrice = hasOffer
      ? offerPrice
      : originalPrice;

    const discountPercent =
      hasOffer && originalPrice > 0
        ? Math.round(
            ((originalPrice - offerPrice) /
              originalPrice) *
              100
          )
        : 0;

    /* =========================
       QUANTITY
    ========================= */

    const [quantity, setQuantity] = useState(1);

    useEffect(() => {
      setQuantity(1);
    }, [id]);

    /* =========================
       INCREASE
    ========================= */

    const handleIncrease = (e) => {
      e.stopPropagation();

      if (!isLoggedIn) {
        toast.error("Please login first");
        return;
      }

      setQuantity((prev) => {
        if (prev >= maxQty) {
          return prev;
        }

        return prev + 1;
      });
    };

    /* =========================
       DECREASE
    ========================= */

    const handleDecrease = (e) => {
      e.stopPropagation();

      if (!isLoggedIn) {
        toast.error("Please login first");
        return;
      }

      setQuantity((prev) =>
        prev > 1 ? prev - 1 : 1
      );
    };

    /* =========================
       ADD TO CART
    ========================= */

    const handleAddToCart = (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!isLoggedIn) {
        toast.error("Please login first");
        return;
      }

      if (maxQty < 1) {
        toast.error("Product is out of stock");
        return;
      }

      if (isInCart) {
        toast.error("Already in cart");
        return;
      }

     addToCart(
  {
    product_id: id,
    product_variant_item_id: activeVariant?.id,
    quantity: quantity,
  },
  {
    onSuccess: () => {
      toast.success("Item added to cart 🛒");
    },
  }
);
    };

    return (
      <div
        ref={ref}
        className={styles.productCard}
      >
        {/* =========================
            PRODUCT LINK
        ========================= */}

        <Link
          to={`/productdetails/${slug}`}
          className={
            imageOnly
              ? styles.categoryCardLink
              : ""
          }
        >
          {/* =========================
              IMAGE
          ========================= */}

          <div
            className={`${styles.productImageWrapper} ${
              imageOnly
                ? styles.categoryImageWrapper
                : ""
            }`}
          >
            {!imageOnly && (
              <div className={styles.iconGroup}>
                {/* CART */}

                <button  style={{color:"black"}}
                  className={`${styles.iconBtn} ${
                    isInCart
                      ? styles.disabledCartBtn
                      : ""
                  }`}
                  onClick={handleAddToCart}
                  disabled={isInCart}
                  title="Add to Cart"
                >
                  🛒
                </button>

                {/* WISHLIST */}

                <button
                  className={styles.iconBtn}
                  onClick={handleWishlist}
                  disabled={isWishListPending}
                >
                  {inWishList ? (
                    <FaHeart 
                      size={20}
                      color="#e53935"
                    />
                  ) : (
                    <CiHeart
                      size={20}
                      color="black"
                    />
                  )}
                </button>
              </div>
            )}

            <Image
              src={getImageUrl(thumb_image)}
              alt={name}
              className={`${styles.productImage} ${
                imageOnly
                  ? styles.categoryImage
                  : ""
              }`}
            />
          </div>

          {/* =========================
              PRODUCT NAME
          ========================= */}

          <div
            className={`${styles.productInfo} ${
              imageOnly
                ? styles.categoryTitle
                : ""
            }`}
          >
            <HeadingTitle
              text={name
                ?.toLowerCase()
                .replace(
                  /\b\w/g,
                  (char) =>
                    char.toUpperCase()
                )}
              style={styles.productName}
            />
          </div>
        </Link>

        {/* =========================
            PRICE
        ========================= */}

        {!imageOnly && (
          <div className={styles.priceWrapper}>
            <div className={styles.priceRow}>
              <p
                className={
                  styles.productPrice
                }
              >
                <LiaRupeeSignSolid />
                {finalPrice}
              </p>

              {hasOffer && (
                <p
                  className={
                    styles.originalPrice
                  }
                >
                  <LiaRupeeSignSolid />
                  {originalPrice}
                </p>
              )}

              {hasOffer && (
                <span
                  className={
                    styles.discountText
                  }
                >
                  {discountPercent}% OFF
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default Product;